import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from 'axios';

Vue.config.productionTip = false;
axios.defaults.baseURL = 'https://sdld-api.wavveanalytics.com';

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app');
